<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:color="page.color"
			:content="page.content"
			:heading-image="page.headingImages && page.headingImages[0]"
		>
			<template #content>
				<div class="row">
					<div class="columns column12 intro-data">
						<span v-if="page.date">
							{{ $d(new Date(page.date.date.split(' ')[0]), 'short', $i18n.locale) }}
						</span>
						<span>{{ page.itemFeature }}</span>
					</div>
					<div :class="page.color" class="columns column12 align-center">
						<h1 v-if="page.headingImages[0] && page.headingImages[0].header">
							{{ page.title }}
						</h1>
						<h1 v-else>
							{{ page.title || page.header }}
						</h1>
						<div v-parse-links v-html="page.content" />
					</div>
				</div>
			</template>
		</main-content>

		<div v-if="page.showIntakeForm" class="main-content eventform-wrapper">
			<div class="row align-center">
				<div
					class="columns column12"
					style="max-width: 600px; margin: 0 auto; display: inline-block; float: none"
				>
					<iframe
						src="https://app.eventtemple.com/lead_intakes/142e4ea61816334c3998660452a49a90/7497/new"
						width="100%"
						height="800px"
						frameborder="0"
					></iframe>
				</div>
			</div>
		</div>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss" scoped>
.intro-data {
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: space-between;
	margin: 0 0 15px;

	span {
		color: #000;
		font-weight: 400;
		font-family: 'courier_newregular', MessinaSerif, serif;
		text-transform: uppercase;
		font-size: 14px;
	}
}

.rooms-items {
	margin-bottom: 5px;
	padding: 50px 0;

	.row {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
	}

	h3 {
		margin: 0;
	}

	.column12 {
		h3 {
			margin: 0 0 20px;
		}
	}

	img {
		margin: 20px 0;
	}
}
</style>
